<template>
  <div class="wrapper-login">
    <div class="img-login">
    </div>

    <div class="form p-3">
      <!-- Logo Form -->
      <div class="d-flex justify-content-center mb-4">
        <img class="logo" src="../assets/images/factorylogo.jpg" alt="">
      </div>

      <!-- Alert user incorrect  -->
      <div v-if="alertUserIncorrect" class="alert alert-danger" role="alert">
        <i class="fas fa-exclamation-circle"></i> The password or email you entered is incorrect
      </div>

      <!-- Email -->
      <div class="input-group input-group-sm">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <input
          type="email" class="form-control" required
          placeholder="Email"
          v-model="email">
      </div>
      <div v-if="alertEmail" class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-circle"></i> Email is requerid
      </div>

      <!-- Password -->
      <div class="input-group input-group-sm mt-3">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-lock"></i>
          </span>
        </div>
        <input
          :type="showPassword ? 'text' : 'password'"
          class="form-control"
          placeholder="Password"
          v-model="password">
        <div class="input-group-append">
          <button type="button" class="input-group-text btn" @click="showPassword = !showPassword">
            <i v-if="!showPassword" class="fas fa-eye"></i>
            <i v-else class="fas fa-eye-slash"></i>
          </button>
        </div>
      </div>
      <div v-if="alertPassword" class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-circle"></i> Password is requerid
      </div>

      <!-- Login -->
      <div class="d-flex justify-content-center mt-3">
        <button
          type="button" class="btn btn-primary"
          @click="initLogin">
          Login
        </button>
      </div>
    </div>
    <!-- <footer>{{ year }} © PrimaFormsFactory(TM) by Brevort River Studios, LLC</footer> -->
  </div>
</template>

<script>
import bcrypt from 'bcryptjs'

export default {
  name: 'list-view',

  data () {
    return {
      email: null,
      password: null,
      showPassword: false,
      alertPassword: false,
      alertEmail: false,
      alertUserIncorrect: false
      // year: new Date().getFullYear()
    }
  },

  methods: {
    async initLogin () {
      if (this.validateInputs()) {
        // Comprobar si el usuario existe
        const dbUser = await this.getUser()

        if (dbUser !== null) {
          let validatePassword = await this.comparePassword(dbUser.password)

          if (validatePassword) {
            let newAccess = await this.getAccessToken()
            this.$store.commit('setAuthentication', {
              email: newAccess.email,
              accessToken: newAccess.accessToken
            })
            localStorage.setItem('accesToken', newAccess.accessToken)
            // Go Home
            this.$router.push('/')
          } else {
            this.alertUserIncorrect = true
          }
        } else {
          this.alertUserIncorrect = true
        }
      }
    },

    async getUser () {
      return this.axios.post(this.$store.state.apiUrl + 'get-user-by-email', {
        email: this.email
      })
      .then(response => response.data.data)
    },

    async getAccessToken () {
      return this.axios.post(this.$store.state.apiUrl + 'kento', {
        email: this.email
      })
      .then(response => response.data.data)
    },

    validateInputs () {
      this.alertEmail = this.email === null || this.email === ''
      this.alertPassword = this.password === null || this.password === ''

      return this.alertEmail === false && this.alertPassword === false
    },

    async comparePassword (encryptedPassword) {
      try {
        return await bcrypt.compare(this.password, encryptedPassword)
      } catch (error) {
        console.error('Fail compare password', error)
        return false
      }
    }

    // async encryptPassword () {
    //   try {
    //     let password = 'Prima1234!'
    //     const encryptedPassword = await bcrypt.hash(password, 10)

    //     console.log('Contraseña encriptada: ', encryptedPassword)
    //   } catch (error) {
    //     console.error('Error al encriptar y guardar la contraseña:', error)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.wrapper-login {
  display: grid;
  justify-content: center;
  align-items: center;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  .img-login {
    width: 100%;
    height: 100%;
    background-image: url('../assets/images/background-login.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .logo {
    width: -webkit-fill-available;
    max-width: 500px;
  }

  .alert-warning {
    padding: 5px !important;
  }

  .form {
    max-width: 450px;
    margin: auto;
  }

  // footer {
  //   justify-content: center;
  //   margin: 20px 0;
  //   text-align: center;
  //   grid-column: 1 / span 2;
  // }
}

.custom-pointer {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/views/LoginView.vue